import React from 'react';
import Card from '../../components/elements/Card';
import Center from '../../components/css/Center';
import Image from '../../components/images/Image';
import Title from '../../components/common/Title';
import Loading from '../../components/common/Loading';
import { useTranslation } from 'react-i18next';

const NotFound = ({ translationKey = 'notFound', loading = false }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <Card className="mt-1" p="3">
        <Loading size="lg" />
      </Card>
    );
  }

  return (
    <Card className="mt-1" p="3">
      <Center>
        <Image url={require('./../../assets/images/not-found.png')} className="my-4" />
      </Center>
      <Title heading="6" my="0">
        {t(translationKey)}
      </Title>
    </Card>
  );
};

export default NotFound;
